import ProductPrinter from "./productPrinter";

export default class AccessoiresPrinter extends ProductPrinter {}
